if (!customElements.get('yoniq-video-guide')) {
  customElements.define('yoniq-video-guide', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.toggle = this.querySelector('[data-video-toggle]');
      this.label = this.querySelector('[data-video-toggle-label]');
      this.status = this.querySelector('[data-video-status]');
      this.chapters = Array.from(this.querySelectorAll('[data-video-seek]'));
      this.toggle.addEventListener('click', () => {
        if (this.video.paused || this.video.ended) {
          if (this.video.ended) this.video.currentTime = 0;
          this.start();
        } else {
          this.video.pause();
        }
      }, options);
      this.chapters.forEach(button => button.addEventListener('click', () => {
        const seek = () => {
          this.video.currentTime = Math.min(Number(button.dataset.videoSeek), this.video.duration || 0);
          this.start();
        };
        if (this.video.readyState >= 1) seek();
        else this.video.addEventListener('loadedmetadata', seek, { once: true, signal: this.controller.signal });
      }, options));
      ['play', 'pause', 'ended', 'timeupdate', 'loadedmetadata'].forEach(event => this.video.addEventListener(event, () => this.update(), options));
      this.update();
    }
    start() {
      this.status.textContent = '';
      this.video.play().catch(() => { this.status.textContent = this.dataset.playError; });
      const box = this.video.getBoundingClientRect();
      if (box.top < 0 || box.bottom > window.innerHeight) {
        this.querySelector('.yq-video-lesson__frame').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      }
    }
    update() {
      const video = this.video;
      this.label.textContent = video.ended ? this.dataset.replayLabel : !video.paused ? this.dataset.pauseLabel : video.currentTime > 0 ? this.dataset.resumeLabel : this.dataset.playLabel;
      this.toggle.querySelector('path').setAttribute('d', video.paused ? 'm8 5 11 7-11 7Z' : 'M7 5h4v14H7zM14 5h4v14h-4z');
      if (Number.isFinite(video.duration)) {
        const seconds = Math.round(video.duration);
        this.querySelector('[data-video-duration]').textContent = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
      }
      this.chapters.forEach((button, index) => {
        const next = this.chapters[index + 1];
        const current = video.currentTime >= Number(button.dataset.videoSeek) && (!next || video.currentTime < Number(next.dataset.videoSeek));
        if (current) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.video?.pause();
    }
  });
}
